/* eslint-disable  */

// ** Redux Imports
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { referralBounce } from "../../../../api/Api";

export const getAllReferralBounce = createAsyncThunk(
  "appReferralBounce/getAllReferralBounce",
  async (query) => {
    try {
      return referralBounce.getAll(query);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllReferralBounceAdmin = createAsyncThunk(
  "appReferralBounce/getAllReferralBounceAdmin",
  async (values) => {
    try {
      return referralBounce.getAllAdmin(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const getAllReferralBounceCheck = createAsyncThunk(
  "appReferralBounce/getAllReferralBounceCheck",
  async (values) => {
    try {
      return referralBounce.getAllCheck(values);
    } catch (error) {
      console.error(error);
    }
  }
);

export const setPaidOrderInReferral = createAsyncThunk(
  "appReferralBounce/setPaidOrderInReferral",
  async (data) => {
    try {
      return data;
    } catch (error) {
      console.error(error);
    }
  }
);
export const setPaidOrderInReferralBonus = createAsyncThunk(
  "appReferralBounce/setPaidOrderInReferralBonus",
  async (data) => {
    try {
      return data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const setPaidOrderInReferralFechedFalse = createAsyncThunk(
  "appReferralBounce/setPaidOrderInReferralFechedFalse",
  async () => {
    try {
      return;
    } catch (error) {
      console.error(error);
    }
  }
);

export const payReferralBounce = createAsyncThunk(
  "appReferralBounce/payReferralBounce",
  async (values) => {
    return referralBounce.payReferralBounce(values);
  }
);

export const appReferralBounceSlice = createSlice({
  name: "appReferralBonus",
  initialState: {
    referralBounce: [],
    referralBounceCheck: [],
    referralBounceMeta: {},
    referralBounceAdmin: [],
    referralBounceFetch: false,
    referralBounceAdminFetch: false,
    referralBounceCheckFetch: false,
    getAllReferralBounceAdminFetch: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllReferralBounce.fulfilled, (state, action) => {
        if (action?.payload?.status !== 200) {
          state.referralBounce = [];
          state.referralBounceFetch = false;
          return;
        }
        state.referralBounce = action.payload?.data?.data;
        state.referralBounceMeta = action.payload.data.totals;
        state.referralBounceFetch = true;
      })
      .addCase(getAllReferralBounceAdmin.fulfilled, (state, action) => {
        if (action.payload.status !== 200) {
          state.referralBounceAdmin = [];
          state.referralBounceAdminFetch = false;
          return;
        }
        state.referralBounceAdmin = action.payload?.data?.data;
        state.referralBounceAdminFetch = true;
      })

      .addCase(getAllReferralBounceCheck.fulfilled, (state, action) => {
        if (action.payload.status !== 200) {
          state.referralBounceCheck = [];
          state.referralBounceCheckFetch = false;
          return;
        }
        state.referralBounceCheck = action.payload?.data?.data;
        state.referralBounceCheckFetch = true;
      })
      .addCase(setPaidOrderInReferral.fulfilled, (state, action) => {
        state.getAllReferralBounceAdminFetch = true;
        const updatedArray = [...action.payload.store];
        let index = 0;
        const updatedReferralBounceAdmin = {
          ...action.payload.store.find((x, i) => {
            index = i;
            return x?.referral?._id === action?.payload?.id;
          }),
          ...action.payload.data,
        };

        updatedArray[index] = updatedReferralBounceAdmin;
        state.referralBounceAdmin = updatedArray;
      })
      .addCase(setPaidOrderInReferralBonus.fulfilled, (state, action) => {
        state.getAllReferralBounceAdminFetch = true;
        const updatedArray = [...action.payload.store];
        let index = 0;
        const updatedReferralBounce = {
          ...action.payload.store.find((x, i) => {
            index = i;
            return x?.parentId?._id === action.payload.id;
          }),
          ...action.payload.data,
        };

        updatedArray[index] = updatedReferralBounce;
        state.referralBounce = updatedArray;
      })

      .addCase(setPaidOrderInReferralFechedFalse.fulfilled, (state, action) => {
        state.getAllReferralBounceAdminFetch = false;
      });
  },
});

export default appReferralBounceSlice.reducer;
